// extracted by mini-css-extract-plugin
export default {"wrapper":"GoToTop_wrapper__zULM6","top-btn":"GoToTop_top-btn__uul2b","icon":"GoToTop_icon__DM6N8","gototop":"GoToTop_gototop__+J6ai","reveal":"GoToTop_reveal__MjP+y"};